import React from "react";

const MoveRightLastPageIcon = ({ className, disabled }) => (
  <>
    <svg
      className={className}
      width='23'
      height='24'
      viewBox='0 0 23 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.8787 11.6478L8.31979 5.8228C8.26622 5.75315 8.18229 5.71387 8.09479 5.71387H6.71444C6.59479 5.71387 6.52872 5.85137 6.60194 5.94422L11.3412 11.9996L6.60194 18.0549C6.58545 18.076 6.57522 18.1013 6.57241 18.1279C6.56961 18.1545 6.57435 18.1813 6.58608 18.2053C6.59782 18.2294 6.61608 18.2496 6.63878 18.2637C6.66147 18.2779 6.68769 18.2854 6.71444 18.2853H8.09479C8.18229 18.2853 8.26622 18.2442 8.31979 18.1764L12.8787 12.3532C13.0412 12.1442 13.0412 11.8549 12.8787 11.6478ZM18.3073 11.6478L13.7484 5.8228C13.6948 5.75315 13.6109 5.71387 13.5234 5.71387H12.143C12.0234 5.71387 11.9573 5.85137 12.0305 5.94422L16.7698 11.9996L12.0305 18.0549C12.014 18.076 12.0038 18.1013 12.001 18.1279C11.9982 18.1545 12.0029 18.1813 12.0147 18.2053C12.0264 18.2294 12.0447 18.2496 12.0673 18.2637C12.09 18.2779 12.1163 18.2854 12.143 18.2853H13.5234C13.6109 18.2853 13.6948 18.2442 13.7484 18.1764L18.3073 12.3532C18.4698 12.1442 18.4698 11.8549 18.3073 11.6478Z'
        fill={disabled ? "var(--du-color-grey)" : "var(--du-color-black)"}
      />
    </svg>
  </>
);

export default MoveRightLastPageIcon;
